import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./dataTables.css";

export default function DataTables(props) {
  const data = props.data;
  const [orderBy, setOderBy] = useState({ col: 0, asc: true });
  const [rowsPerPage, setRowsPerPage] = useState(data.length);
  const [pageActual, setPageActual] = useState(props.lastPage || 0);
  const [resize, setResize] = useState(false);
  const tableRef = useRef(null);

  const sortData = (dataToSort, sortConfig) => {
    if (!sortConfig.col) {
      return [...dataToSort];
    }
    return [...dataToSort].sort((a, b) => {
      if (a[sortConfig.col] > b[sortConfig.col]) {
        return sortConfig.asc ? 1 : -1;
      }
      if (a[sortConfig.col] < b[sortConfig.col]) {
        return sortConfig.asc ? -1 : 1;
      }
      return 0;
    });
  };

  const sortedData = sortData(data, orderBy);

  useEffect(() => {
    if (props.paginate && tableRef.current) {
      const height = tableRef.current.clientHeight;
      const newRows = Math.trunc(height / 35);
      setRowsPerPage(newRows);
    }
  }, [sortedData, props.paginate, resize]);

  useEffect(() => {
    const handleResize = () => {
      setResize((prev) => !prev);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function getRows() {
    let rows = [];
    const startIndex = rowsPerPage * pageActual;
    const endIndex = Math.min(startIndex + rowsPerPage, sortedData.length);

    if (sortedData.length > 0) {
      for (let i = startIndex; i < endIndex; i++) {
        rows.push(
          <TableRow key={i}>
            {sortedData[i].map((cell, index) => (
              <TableCell key={index}>{cell}</TableCell>
            ))}
          </TableRow>
        );
      }
    } else {
      return null;
    }
    return rows;
  }

  function getPaginate() {
    const totalPages = Math.ceil(sortedData.length / rowsPerPage);
    let buttons = [];

    buttons.push(
      <button
        key={"Anterior"}
        onClick={() => {
          if (pageActual > 0) {
            setPageActual(pageActual - 1);
            if (props.setLastPage) {
              props.setLastPage(pageActual - 1);
            }
          }
        }}>
        Anterior
      </button>
    );

    if (totalPages > 6) {
      if (pageActual <= 2) {
        for (let i = 0; i < 3; i++) {
          buttons.push(
            <button
              key={i + 1}
              onClick={() => {
                setPageActual(i);
                if (props.setLastPage) {
                  props.setLastPage(i);
                }
              }}
              className={pageActual === i ? "active" : null}>
              {i + 1}
            </button>
          );
        }
        buttons.push(<button key={"..."}>...</button>);
      } else if (pageActual >= totalPages - 3) {
        buttons.push(<button key={"..."}>...</button>);
        for (let i = totalPages - 3; i < totalPages; i++) {
          buttons.push(
            <button
              key={i + 1}
              onClick={() => {
                setPageActual(i);
                if (props.setLastPage) {
                  props.setLastPage(i);
                }
              }}
              className={pageActual === i ? "active" : null}>
              {i + 1}
            </button>
          );
        }
      } else {
        buttons.push(<button key={"..."}>...</button>);
        for (let i = pageActual - 2; i < pageActual + 3; i++) {
          buttons.push(
            <button
              key={i + 1}
              onClick={() => {
                setPageActual(i);
                if (props.setLastPage) {
                  props.setLastPage(i);
                }
              }}
              className={pageActual === i ? "active" : null}>
              {i + 1}
            </button>
          );
        }
        buttons.push(<button>...</button>);
      }
    } else {
      for (let i = 0; i < totalPages; i++) {
        buttons.push(
          <button
            key={i + 1}
            onClick={() => {
              setPageActual(i);
              if (props.setLastPage) {
                props.setLastPage(i);
              }
            }}
            className={pageActual === i ? "active" : null}>
            {i + 1}
          </button>
        );
      }
    }
    buttons.push(
      <button
        key={"Siguiente"}
        onClick={() => {
          if (pageActual < totalPages - 1) {
            setPageActual(pageActual + 1);
            if (props.setLastPage) {
              props.setLastPage(pageActual + 1);
            }
          }
        }}>
        Siguiente
      </button>
    );

    return <div className="contenedor-buttons">{buttons}</div>;
  }

  return (
    <>
      <div
        ref={tableRef}
        style={
          props.paginate
            ? {
                height: "calc(100% - 60px)",
                overflow: "hidden",
                position: "relative",
              }
            : { height: "100%", overflow: "auto", position: "relative" }
        }>
        <Table stickyHeader className="table-dash">
          <TableHead>
            <TableRow>
              {props.headers.map((header, index) => (
                <TableCell
                  key={header}
                  className="HeadCell"
                  col={index}
                  onClick={(e) => {
                    const columnIndex = parseInt(
                      e.target.getAttribute("col"),
                      10
                    );
                    if (columnIndex === orderBy.col) {
                      setOderBy({ ...orderBy, asc: !orderBy.asc });
                    } else {
                      setOderBy({ col: columnIndex, asc: true });
                    }
                  }}>
                  {header}
                  <div className="HeadArrows">
                    <ArrowDropUpIcon
                      style={
                        orderBy.col === index && orderBy.asc
                          ? { color: "red" }
                          : null
                      }
                    />
                    <ArrowDropDownIcon
                      style={
                        orderBy.col === index && !orderBy.asc
                          ? { color: "red" }
                          : null
                      }
                    />
                  </div>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {props.loading ? null : <TableBody>{getRows()}</TableBody>}
        </Table>
        {props.loading ? (
          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              position: "absolute",
              width: "100%",
            }}>
            <CircularProgress size={50} />
          </div>
        ) : null}
        {sortedData.length === 0 && !props.loading ? (
          <p
            style={{
              textAlign: "center",
              width: "100%",
              position: "absolute",
            }}>
            No hay registros que mostrar.
          </p>
        ) : null}
      </div>
      {props.paginate ? getPaginate() : null}
    </>
  );
}
